export function setupScrollToElement() {
  const VALID_ID_PATTERN = /^[a-zA-Z0-9_-]+$/;

  document.addEventListener("click", (event) => {
    const triggerElement = event.target.closest("[data-scroll-target]");
    if (!triggerElement) return;

    event.preventDefault();

    const targetId = triggerElement.getAttribute("data-scroll-target");

    if (!VALID_ID_PATTERN.test(targetId)) {
      console.warn(`Invalid scroll target ID: "${targetId}".`);
      return;
    }

    const targetElement = document.querySelector(
      `[data-scroll-id="${targetId}"]`,
    );
    if (!targetElement) {
      console.warn(`No element found with data-scroll-id="${targetId}".`);
      return;
    }

    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
}
